import clsx from 'clsx';
import styles from './Card.module.css';

export function CardTitle({ className = '', children, as = 'h2', ...rest }) {
  const Tag = as;
  return (
    <Tag className={clsx(styles.title, className)} {...rest}>
      {children}
    </Tag>
  );
}
